import { useExperiencesContext } from '../../experiences/Experiences';
import {
  useCompareContext,
  useFacetContext,
  useHeaderPeepingContext,
  usePlpBodySentinelContext,
  useSearchContext,
} from '../../../context/PlpContext';

export const useFacetsData = () => {
  const experiences = useExperiencesContext();
  const facetContext = useFacetContext();
  const searchContext = useSearchContext();

  const { products: compareProducts } = useCompareContext();
  const isCompareBarOpen = compareProducts?.length > 0;

  const { isHeaderPeeping } = useHeaderPeepingContext();
  const { plpBodySentinelRef } = usePlpBodySentinelContext();

  return {
    experiences,
    facetContext,
    searchContext,
    isHeaderPeeping,
    plpBodySentinelRef,
    isCompareBarOpen,
  };
};
